module.exports = __webpack_public_path__ + "static/media/sketch-app-1.f45d2413.jpg";